import React from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import { BlogData } from "../pages/blog/BlogData";
import { Link } from "react-router-dom";

const RecentPostsSection = () => {
  React.useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const posts = BlogData.posts
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  //=================== main_return_function =============//
  return (
    <section id="blog-posts" className="blog-posts section">
      <div
        className="container section-title flex flex-col justify-center items-center"
        data-aos="fade-up"
      >
        <h2 className="font-[poppins] !font-bold !text-[24px] md:!text-[34px]">
          Latest Insights &
          <span className="font-[Playfair] ml-1 italic text-[#9bd66c]">
            Updates
          </span>
        </h2>
        <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>

        <p className="lead !text-[16px]">
          Explore our recent articles and stay informed on the latest trends in
          technology and business.
        </p>
      </div>
      <div className="container">
        <div className="row gy-4">
          {posts.slice(0, 3).map((post) => (
            <div className="col-lg-4" key={post.id}>
              <article>
                <div className="post-img">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="img-fluid"
                  />
                </div>
                <p className="post-category">{post.categories[0]}</p>
                <h2 className="title">
                  <Link to={`/blog-details/${post.id}`}>{post.title}</Link>
                </h2>
                <div className="d-flex gap-3 align-items-center">
                  <img
                    src={post.author.image}
                    alt={post.author.image}
                    className="w-[50px] h-[50px] rounded-full flex-shrink-0"
                  />
                  <div className="post-meta">
                    <p className="post-author">{post.author.name}</p>
                    <p className="post-date">
                      <time>{post.date}</time>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentPostsSection;
